import { MAIL_REGEX } from 'gcs-common/constants/formValidation';

export function cleanPhoneNumber(n: string) {
  let cleaned = n;
  // 0049 to +49
  cleaned = cleaned.replace(/^0049/, '+49');
  // 0 to +49
  cleaned = cleaned.replace(/^0/, '+49');
  // remove all spaces and non-numeric stuff
  cleaned = cleaned.replace(/[\s-/.()]/g, '');

  return cleaned;
}

/**
 * Brings a typed phone number into E.164 format, e.g. "+49 (0)7022 9255-563" -> "+4970229255563".
 * Only separators are removed, so letters etc. remain and fail validation.
 */
export function normalizePhoneNumber(n: string) {
  const cleaned = n.replace(/\(0\)/g, '').replace(/[\s()\-/.]/g, '');
  // 0049 to +49, 0 to +49
  return cleaned.replace(/^00/, '+').replace(/^0/, '+49');
}

/**
 * Splits a "phone number or email" input into a trimmed email or a normalized phone number.
 */
export function parsePhoneOrEmail(value: string): { email: string } | { phoneNumber: string } {
  const trimmed = value.trim();
  return MAIL_REGEX.test(trimmed) ? { email: trimmed } : { phoneNumber: normalizePhoneNumber(trimmed) };
}
